import React, { FC } from 'react';
import NextjsLink, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';

interface Props extends LinkProps {
  inlineStyles?: React.CSSProperties;
}

const Link: FC<Props> = (props) => {
  const { children, href, inlineStyles } = props;
  const router = useRouter();
  const isCoWriter = router.pathname.includes('/co-writer');

  if (typeof href === 'string' && isCoWriter) {
    return (
      <a href={href} style={inlineStyles}>
        {children}
      </a>
    );
  }
  return <NextjsLink {...props}>{children}</NextjsLink>;
};

export default Link;
